const LoadingTimeout = (num) => {
  let result = false;
  setTimeout(() => {
    result = true;
  }, num);

  return result;
};

const continuationCalculator = (birthday) => {
  let day1 = new Date(birthday);

  let day2 = new Date();

  let diff = Math.floor(Math.abs(day2 - day1) / (1000 * 3600 * 24));

  return diff;
};

const dateFormatter = (newDate) => {
  const dateString = newDate;
  const date = new Date(dateString);

  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const monthsOfYear = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const dayOfWeek = daysOfWeek[date.getDay()];
  const dayOfWeekTest = date.getDay();

  const dayOfMonth = date.getDate();

  const month = monthsOfYear[date.getMonth()];
  const year = date.getFullYear();

  let suffix;
  if (dayOfMonth === 1 || dayOfMonth === 21 || dayOfMonth === 31) {
    suffix = "st";
  } else if (dayOfMonth === 2 || dayOfMonth === 22) {
    suffix = "nd";
  } else if (dayOfMonth === 3 || dayOfMonth === 23) {
    suffix = "rd";
  } else {
    suffix = "th";
  }

  return `${dayOfWeek} ${dayOfMonth}${suffix} ${month} ${year}`;
};

const isUrl = (str) => {
  // Regular expression to match URL pattern
  const urlPattern =
    /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
  return urlPattern.test(str);
};

const ZeroRemove = (array) => {
  let lastItem = array.length - 1;

  if (array[lastItem] === undefined || isNaN(array[lastItem])) {
    return array.pop();
  }

  if (array[lastItem].es || array[lastItem].endScore) {
    if (
      array[lastItem].es === undefined ||
      isNaN(array[lastItem].es) ||
      array[lastItem].endScore === undefined ||
      isNaN(array[lastItem].endScore)
    ) {
      return array.pop();
    }
  } else if (array[lastItem].total) {
    if (array[lastItem].total === undefined || isNaN(array[lastItem].total)) {
      return array.pop();
    }
  } else if (array[lastItem].tcr) {
    if (array[lastItem].tcr === undefined || isNaN(array[lastItem].tcr)) {
      return array.pop();
    }
  } else if (array[lastItem].wave) {
    if (array[lastItem].wave === undefined || isNaN(array[lastItem].wave)) {
      return array.pop();
    }
  } else {
    return array;
  }
};

const memorySelector = (days) => {
  if (!days || !days.length) return null;

  // endScore of 0 is a real score, so test for presence rather than truthiness.
  const memArray = days
    .filter(
      (d) =>
        d.rememberToday &&
        d.logDate &&
        d.endScore !== undefined &&
        d.endScore !== null
    )
    .map((d) => ({ date: d.logDate, memory: d.rememberToday }));

  if (!memArray.length) return null;

  // Index 0 is a valid pick — guarding on the index's truthiness used to drop
  // the first memory entirely and return 0 instead of an entry.
  const randomIndex = Math.floor(Math.random() * memArray.length);

  return memArray[randomIndex];
};

const labelMaker = (text) => {
  if (!text) return "...";
  let arr = text.split(" ").filter((t) => t != "" || t != " ");
  let len = arr.length;

  // console.log(arr);
  // console.log(len);

  if (len === 1) {
    return arr[0].slice(0, 2) + ".";
  } else if (len === 2) {
    try {
      let label = arr
        .slice(0, 2)
        .reduce((acc, value) => acc[0][0] + value[0][0]);
      return label;
    } catch (error) {
      console.log("label", error);
    }
  } else if (len > 2) {
    let label = arr.slice(0, 2).reduce((acc, value) => acc[0][0] + value[0][0]);

    return label + ".";
  } else {
    // let label = arr.slice(0, 2).reduce((acc, value) => acc[0][0] + value[0][0]);
    let label = "...";
    return label;
  }
};

export {
  LoadingTimeout,
  continuationCalculator,
  ZeroRemove,
  dateFormatter,
  isUrl,
  memorySelector,
  labelMaker,
};
